import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const ViewUserSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const ViewUserPrimaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)] sm:w-auto",
})``;

export const ViewUserGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const ViewUserGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

export const ViewUserGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-5 xl:grid-cols-[11.5rem_minmax(0,1fr)] xl:items-start",
})``;

export const ViewUserSection = styled.div.attrs({
  className: "brand-panel-muted flex flex-col items-center text-center sm:items-start sm:text-left",
})``;

export const ViewUserEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const ViewUserPreviewImage = styled(FallbackImage).attrs({
  className: "mt-4 h-32 w-32 max-w-full rounded-[22px] sm:h-40 sm:w-40 sm:rounded-[24px]",
})``;

export const ViewUserTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const ViewUserDetailsGrid = styled.div.attrs({
  className: "grid gap-4 sm:grid-cols-2 xl:grid-cols-3",
})``;

export const ViewUserSectionSecondary = styled.div.attrs({
  className: "rounded-[22px] bg-[rgba(255,255,255,0.04)] px-4 py-4",
})``;

export const ViewUserGridLayoutQuaternary = styled.div.attrs({
  className: "grid gap-4 sm:grid-cols-2",
})``;

export const ViewUserMetaText = styled.p.attrs({
  className: "mt-2 text-sm text-[var(--brand-muted)]",
})``;

export const ViewUserGridLayoutQuinary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-2",
})``;

